












































import { watch, computed, defineComponent, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api';
import { AddIcon } from 'tdesign-icons-vue';

// 引入组件
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import TeamOrMemberItem from '@/renderer/components/drawer/MemberManage/components/TeamOrMemberItem.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import useOrgTreeStructure from '@/renderer/components/dialog/AddTransfer/compositions/useOrgTreeStructure';
import authHandler, { ConfirmAuthParams } from '@/renderer/components/SpacePage/compositions/authHandler';

// 引入工具类
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import store from '@/renderer/store';
import tips from '@/renderer/scripts/utils/tips';
import { PAY_PLAN_MAP } from '@/renderer/scripts/utils/ConstantConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
import { LOCATION_MAP } from '@/common/reporter/utils';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';

export default defineComponent({
  name: 'FileMemberManage',
  components: {
    AddIcon,
    AddFileAuth,
    TeamOrMemberItem,
  },
  props: {
    params: {
      required: false,
      type: Object as () => Drawer.AuthParams<SMH.SpaceFileItemData>,
      default: null,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    // 团队版只读
    const hasLicense = computed(() => store.getters.editionFlag === PAY_PLAN_MAP.EnterPrise);
    const { params } = toRefs(props);

    // 当前选中项
    const data = computed<SMH.SpaceFileItemData>(() => params.value.selectedItem);
    const spaceId = computed(() => params.value.spaceId);
    // 是否拥有操作权限（删除/增加）
    // 文件的管理权限，依赖于当前人员的最高权限
    const canOperator = computed<Boolean>(() => data?.value?.authorityList?.canAuthorize);
    const routerName = vm.$route.name;
    // TODO
    const { loading: listLoading } = useOrgTreeStructure();

    /**
     * 对Permission进行排序，
     * @param list
     */
    const sortPermission = (list: CoFile.TeamOrMemberItem[]) => {
      const ownerRoleId = vm.$store.getters.ownerRole?.id;
      return list.sort((a, b) => {
        // 所有者权限排最前面
        if (a.roleId) {
          if (a.roleId !== ownerRoleId && b.roleId === ownerRoleId) return 1;
        }
        // 团队排在用户前面
        if (a.spaceId) {
          if (a.spaceId && !b.spaceId) return -1;
        }
        if (a.disabledOperate) {
          // 不支持操作的排序到最前
          if (a.disabledOperate && !b.disabledOperate) return -1;
        }
        // 带标签权限排在不带标签之前
        if (a.tag) {
          if (a.tag !== 0 && b.tag === 0) return -1;
        }
        return 0;
      });
    };
    const {
      show: showAuth,
      authParams,
      dirPermisionList,
      loading: shareLoading,
      hasMore,
      methods: authMethods,
    } = authHandler(spaceId);
    // 个人空间以及与我相关判断
    const noDisableRoleSelect = computed(
      () => props.params.selectedItem?.spaceTag === 'personal' || vm.$route.name === 'personalSpace',
    );
    const renderList = computed(() => sortPermission(dirPermisionList.value as CoFile.TeamOrMemberItem[]));
    const methods = {
      async initData() {
        const item = data.value;
        await methods.getAuthList(item);
      },
      async getAuthList(item: SMH.SpaceFileItemData) {
        if (item.type !== 'dir' && item.type !== 'file') return;
        const _teamId = vm.$route.query?.teamId;
        const teamId = _teamId ? +_teamId : undefined;

        let spaceTag: SpaceTag | null = null;
        if (vm.$route.name === 'teamSpace') spaceTag = SpaceTag.team;
        if (vm.$route.name === 'personalSpace') spaceTag = SpaceTag.personal;
        if (vm.$route.name === 'collaborationSpace') spaceTag = SpaceTag.group;

        // 获取共享列表
        const params = {
          path: (item.path as string[]).join('/'),
          spaceTag: item.spaceTag || spaceTag,
          teamId,
        };
        Object.assign(authParams, { params });
        authMethods.initAuthDir(params, {
          limit: 30,
        });
      },
      scroll(options: { e: Event | WheelEvent; scrollTop: number; scrollBottom: number }) {
        if (shareLoading.value || !hasMore) return;
        const { scrollBottom } = options;
        if (scrollBottom <= 20) {
          authMethods.getDirPermissions({ limit: 30 });
        }
      },
      async onAuthSaved(isSuccess: boolean) {
        if (isSuccess) {
          const item = data.value as SMH.SpaceFileItemData;
          await methods.getAuthList(item);
          // 由于h5页面是抽屉形式，无需刷新整个页面
          if (!store.getters.isMobileStyle) {
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
          }
        }
      },
      // 弹窗之后添加成员
      async onConfirmAuth(params: ConfirmAuthParams) {
        const isSuccess: boolean = await authMethods.onConfirmAuth(params);
        methods.onAuthSaved(isSuccess);
      },
      async onAuthOperate(action: string, item?: CoFile.TeamOrMemberItem) {
        if (action === 'add') {
          if (checkIfMobileStyle()) return;
          showAuth.value = true;
          reporter.report('member', {
            operateType: 'add',
            operateLocation: LOCATION_MAP[routerName as string],
          });
        }
        if (action === 'delete') {
          const deleteDialog = CustomDialog.confirm({
            header: i18n_t('提示'),
            body: i18n_t('是否要删除对 {slot1} 的授权？', {
              slot1: (item as CoFile.TeamOrMemberItem).name,
            }),
            theme: 'warning',
            onConfirm: () => {
              const deleted = [item as CoFile.TeamOrMemberItem];
              methods.onConfirmAuth({
                deleted,
              });
              if (deleteDialog.hide) {
                deleteDialog.hide();
              }
              reporter.report('member', {
                operateType: 'del',
                operateLocation: LOCATION_MAP[routerName as string],
              });
            },
          });
        }
        if (action === 'quit') {
          const quitDialog = CustomDialog.confirm({
            header: i18n_t('提示'),
            body: i18n_t('退出后将无法查看群组及群组内共享的文件，确定要退出吗？'),
            theme: 'warning',
            onConfirm: () => {
              const deleted = [item as CoFile.TeamOrMemberItem];
              methods.onConfirmAuth({
                deleted,
              });
              if (quitDialog.hide) {
                quitDialog.hide();
              }
              reporter.report('member', {
                operateType: 'del',
                operateLocation: LOCATION_MAP[routerName as string],
              });
            },
          });
        }
        if (action === 'edit') {
          const changed = [item as CoFile.TeamOrMemberItem];
          await methods.onConfirmAuth({
            changed,
          });
        }
      },
    };
    onMounted(() => {
      methods.initData();
    });
    watch(data, val => {
      if (val) {
        methods.initData();
      }
    });
    return {
      hasLicense,
      renderList,
      shareLoading,
      canOperator,
      showAuth,
      hasMore,
      authParams,
      onAuthOperate: methods.onAuthOperate,
      onConfirmAuth: methods.onConfirmAuth,
      onAuthSaved: methods.onAuthSaved,
      tipDev: () => {
        tips.success(i18n_t('共享管理成员退出，正在开发中..'));
      },
      scroll: methods.scroll,
      listLoading,
      noDisableRoleSelect,
    };
  },
});
